var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeskAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.917 4.16699C14.0874 4.16699 14.6726 4.16699 15.0929 4.44788C15.2749 4.56947 15.4312 4.72572 15.5528 4.90771C15.8337 5.32808 15.8337 5.91327 15.8337 7.08366V15.0003C15.8337 16.5717 15.8337 17.3573 15.3455 17.8455C14.8573 18.3337 14.0717 18.3337 12.5003 18.3337H7.50033C5.92898 18.3337 5.1433 18.3337 4.65515 17.8455C4.16699 17.3573 4.16699 16.5717 4.16699 15.0003V7.08366C4.16699 5.91327 4.16699 5.32808 4.44788 4.90771C4.56947 4.72572 4.72572 4.56947 4.90771 4.44788C5.32808 4.16699 5.91327 4.16699 7.08366 4.16699",
    stroke: "#7161BA",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.16667C7.5 3.24619 8.24619 2.5 9.16667 2.5H10.8333C11.7538 2.5 12.5 3.24619 12.5 4.16667C12.5 5.08714 11.7538 5.83333 10.8333 5.83333H9.16667C8.24619 5.83333 7.5 5.08714 7.5 4.16667Z",
    stroke: "#7161BA",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10L12.5 10",
    stroke: "#7161BA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.333L10.8333 13.333",
    stroke: "#7161BA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskAlt);
export default __webpack_public_path__ + "static/media/desk_alt.7ba1d0a478bae2ae9edec90b0dfc509e.svg";
export { ForwardRef as ReactComponent };